export class BookingPrepayModel {
    mode: string;
    chequeNo: string;
    chequeDate: Date;
    chequeAmount: any;
    prepayRemarks: string;
    signatureImage: string;
    isByPhone: boolean;
    constructor() {
        this.chequeNo = '';
        this.chequeDate = new Date();
        this.chequeAmount = 0;
        this.prepayRemarks = '';
        this.signatureImage = '';
        this.mode = '';
        this.isByPhone = false;
    }
}